import React from "react";
import { Navigate } from "react-router-dom";
import { LOGIN_PATH } from "../../constants";

export const LandingPage: React.FC<{}> = () => {
  return <Navigate to={LOGIN_PATH} />;
};
